import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const packageVisualizerSelectors = (state: IAppState) => state.deployment.packageVisualizer;

export const getSummaryTree = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.summaryTree
);

export const getSelectedFilters = createSelector(
  packageVisualizerSelectors,
  (state: IPackageVisualizerState) => state.filterParameters ? state.filterParameters.selectedFilters : []
);

export const getSelectedObjects = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.selectedCatalogObjectsByType
);

export const getIsLoading = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.isLoading
);

export const getNavigation = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.navigation
);

export const getSearchText = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.filterParameters ? state.filterParameters.searchText : ''
);

export const getPackageDependencies = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.packageDependencies
);

export const SelectedPackageId = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.selectedPackageId
);

export const getError = createSelector(
    packageVisualizerSelectors,
    (state: IPackageVisualizerState) => state.hasError
);
